import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { getGroupedHistoryNotifications, GroupedHistoryNotifications } from '../docbox-tabbed-modal.utilities';
import { catchError, finalize, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { NotificationService } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-docbox-notification-history',
    templateUrl: './docbox-notification-history.component.html',
    styleUrls: ['./docbox-notification-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocBoxNotificationHistoryComponent {
    public notificationsHistory$: Observable<GroupedHistoryNotifications>;
    public isLoading: boolean;

    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        public readonly notificationService: NotificationService,
        public readonly modalInstance: BsModalRef,
    ) {
        this.getNotificationsHistoryData();
    }
    /**
     * Retrieves notifications history set (CRM)
     * upon initialization and on demand (refresh)
     */
    public getNotificationsHistoryData(): void {
        this.isLoading = true;

        this.notificationsHistory$ = this.notificationService.getNotificationsHistory().pipe(
            map((raw) => (raw ? getGroupedHistoryNotifications(raw) : [])),
            catchError((error) => {
                this.log.error(
                    `NotificationHistory Modal Component: getNotificationsHistoryData: Failed to retrieve notifications history data ${error}`,
                );
                return of({});
            }),
            finalize(() => (this.isLoading = false)),
        );
    }

    public trackByKey(index: number, group: { key: string }): string {
        return group.key;
    }

    public refreshData(): void {
        this.getNotificationsHistoryData();
    }
}
